/* eslint-disable ban/ban */
/* components/CollectionFilters
- Used within collection and search templates

Example
<collection-filters>
    [[collection filters content]]
</collection-filters>
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CollectionFilters extends ThemeComponent {
    @Ref() group!: HTMLElement[];
    @Ref() closeFilters!: HTMLButtonElement[];
    @Ref() filter!: HTMLInputElement[];
    @Ref() apply!: HTMLInputElement[];

    init() {
        this.setEventListeners();

        // Show filter options
        this.handleGroupOpen(this.group);

        // Close filter menu
        this.closeFilterMenu(this.closeFilters);
    }

    setEventListeners() {
        const formElement = document.querySelector('.collection-filters__form') as HTMLElement;

        if (!formElement) {
            return; // Exit if the form element is not found
        }

        this.$listen(formElement, 'change', (event) => {
            const target = event.target as HTMLInputElement;

            if (window.innerWidth < 768 && target.classList.contains('collection-filters__group-options__list-item')) {
                return;
            }

            // Get the parent filter group element.
            const filterGroup = target.closest('.collection-filters__group');

            if (!filterGroup) {
                return; // Exit if the filter group is not found
            }

            // Find the label associated with the filter group.
            const filterGroupLabel = filterGroup.querySelector('.collection-filters__group-label')?.textContent;

            // Check if the filter group label indicates it's the size filter.
            if (filterGroupLabel && filterGroupLabel.toLowerCase().includes('size')) {
                // If it is, select the 'in stock' filter before submitting
                const availabilityFilterCheckbox =
                    this.querySelector('.collection-filters__filter--in-stock') as HTMLInputElement;
                if (availabilityFilterCheckbox) {
                    availabilityFilterCheckbox.checked = true;
                }
            }

            // Find the submit button within the current filter group.
            // eslint-disable-next-line max-len
            const submit = target.closest('.collection-filters__group')?.querySelector('[data-ref="apply"]') as HTMLElement;
            submit?.click();

        });
    }


    private handleGroupOpen(groups: HTMLElement[]) {
        for (const group of groups) {
            this.$listen(group, 'click', (event) => {
                // Do not continue for child clicks
                const clickedElement = event.target as HTMLElement;
                const groupOptions = group.querySelector('.collection-filters__group-options');
                if (groupOptions && (clickedElement == groupOptions || groupOptions.contains(clickedElement))) {
                    return;
                }

                for (const sibling of groups) {
                    if (group !== sibling) {
                        sibling.classList.remove('collection-filters__group--open');
                    }
                }
                group.classList.toggle('collection-filters__group--open');
            });
        }
    }

    private closeFilterMenu(closeFilters: HTMLButtonElement[]) {
        for (const closeFilter of closeFilters) {
            this.$listen(closeFilter, 'click', () => {
                // Only run if filters are active
                if (!document.body.classList.contains('collection-filters-active')) {
                    return;
                }

                // Body class
                document.body.classList.remove('collection-filters-active');

                // Filters class
                this.classList.remove('collection-filters--active');
            });
        }
    }
}
